<template>
  <div>
    <backhaul-dashboard :org-id="org().id" />
</div>
</template>

<script>

import BackhaulDashboard from '@/components/dashboard/backhaul/BackhaulDashboard'

export default {

  props: {

    stats: {
      type: Object,
      default: null
    }

  },

  components: {
    BackhaulDashboard
  }

}

</script>
